export default class ProjectData {
  projectTitle = ''

  replacer = (key: any, value: any) => { // eslint-disable-line
    if (key !== 'rules') return value
  }

  rules = {
    projectTitle: [
      (v: string) => !!(v.trim()) || 'A projektnév megadása kötelező!',
      (v: string) => v.trim().length > 5 || 'Túl rövid projektnév!'
    ]
  }
}
